import { useState, type FormEvent } from 'react';
import { useAuth } from '../../stores/auth-context';

interface LoginFormProps {
  onSuccess: (role: string) => void;
}

export function LoginForm({ onSuccess }: LoginFormProps) {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const role = await login(username, password);
      if (role) {
        onSuccess(role);
      } else {
        setError('Неверный логин или пароль');
      }
    } catch {
      setError('Ошибка подключения');
    } finally {
      setLoading(false);
    }
  }

  const inputStyle = 'w-full rounded-lg border border-ct-border bg-ct-surface px-4 py-3 text-sm text-ct-text placeholder:text-ct-text-muted/50 focus:ring-2 focus:ring-ct-primary focus:ring-offset-1 focus:border-ct-primary focus:outline-none transition-all duration-200';

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-ct-bg p-4 overflow-hidden">
      <div className="pointer-events-none fixed inset-0 overflow-hidden -z-10" aria-hidden="true">
        <div className="absolute -top-[30%] -left-[20%] h-[600px] w-[600px] rounded-full bg-gradient-to-br from-ct-primary/15 to-ct-secondary/15 blur-[120px]" />
        <div className="absolute -bottom-[20%] -right-[15%] h-[400px] w-[400px] rounded-full bg-gradient-to-br from-ct-secondary/10 to-ct-primary/10 blur-[100px]" />
      </div>
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm rounded-xl bg-ct-surface border border-ct-border shadow-ct-sm p-8"
      >
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-extrabold tracking-tight text-ct-text">
            Система регистрации участников AGRICOM
          </h1>
        </div>

        {error && (
          <div className="mb-4 rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm font-medium text-red-700">
            {error}
          </div>
        )}

        <div className="mb-5">
          <label className="mb-1.5 block text-sm font-semibold text-ct-text" htmlFor="username">
            Логин
          </label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className={inputStyle}
            required
            autoFocus
          />
        </div>

        <div className="mb-6">
          <label className="mb-1.5 block text-sm font-semibold text-ct-text" htmlFor="password">
            Пароль
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputStyle}
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-full bg-gradient-to-r from-ct-primary to-ct-secondary px-6 py-3 text-sm font-bold text-ct-on-primary shadow-ct-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-ct-md active:scale-[0.98] disabled:opacity-50"
        >
          {loading ? 'Вход...' : 'Войти в систему'}
        </button>
      </form>
    </div>
  );
}
